export default __webpack_public_path__ + "static/media/sergeants_insignia.09cf77ea.png";